import React, { useState } from 'react'
import s from './DocAd.module.css'
import { showHtml } from '@lib/utils/utils'
import Image from "next/legacy/image"
import Link from 'next/link'
import { Button } from '@components/ui'


export interface IListForm {
  content: string
  title: string
  icon: string
}

export interface AccuracySecurityProps {
  title?: string
  buttonText?: string
  variantId?: string
  image?: any
  className?: string
  list?: Array<IListForm>
}

const DocAd: React.FC<AccuracySecurityProps> = ((props) => {
  let {
    list,
    className,
    title,
    buttonText,
    variantId,
    image,
  } = props

  return (
    <div className={`${s.root}`}>
      <div>
        <div className={`grid grid-cols-1 lg:grid-cols-2`}>
          <div className={s.titleCover + ' md:hidden'}>
            {image && <div
              className={s.image + ' block w-full h-full block overflow-hidden relative'} >
              <Image alt='Doc image' priority={false} loading="lazy" src={image} layout='fill' objectFit='cover' />
            </div>}
          </div>
          <div className='md:mr-0 md:ml-space10 xl:mr-space10'>
            <div className={'col-start-2 md:col-start-1 h-full w-full relative'}>
              <div className={s.innerWrapper}>
                <div>
                  <h3 className={`${s.title} md:w-e446`}>{title}</h3>
                </div>
                <div>
                  <div>
                    <ul className={s.list}>
                      {list && list.map((item, index) => {
                        return <li className={s.item + ' relative'} key={index}>
                          <h4 className={`${s.question} text-neutral900 `}>
                            {item.title}
                          </h4>
                          <p className={`font-normal text-paragraph02 text-neutral700 ${s.text}`}
                             dangerouslySetInnerHTML={showHtml(item.content)} />
                          <div className={s.liner} />
                        </li>
                      })}
                    </ul>
                  </div>
                </div>
                {buttonText && variantId &&
                  <div className={'px-10 text-center md:text-left'}>
                    <Link href={'/quick-buy?variantId=' + variantId + '&quantity=1'} legacyBehavior passHref>
                      <Button className={'mt-space12 md:mb-0 md:mt-0'}
                              variant='outlineMedium'
                      >{buttonText}</Button>
                    </Link>
                  </div>
                }
              </div>
            </div>
          </div>
          <div className={s.titleCover + ' hidden md:block'}>
            {image && <div
              className={s.image + ' block w-full h-full block overflow-hidden relative'} >
              <Image alt='Doc image2' src={image} layout='fill' objectFit='cover' />
            </div>}
          </div>
        </div>
      </div>
    </div>
  )
})

export default DocAd
